export const MAX_DOCUMENT_REQUEST_DAYS = 99;

export const SHORT_TEXT_MAX_LENGTH = 256;
export const LONG_TEXT_MAX_LENGTH = 1024;

export const DataType = {
  FREE_TEXT: 'FreeText',
  DOCUMENTS: 'Documents',
  FORMS: 'Forms',
  PAYMENT: 'Payment',
  EXTERNAL_ACTION: 'ExternalAction',
  INCOME_VERIFICATION: 'IncomeVerification',
  SCHEDULE_CLOSING: 'ScheduleClosing',
  INTERNAL_ACTION: 'InternalAction',
  ASSET_VERIFICATION: 'AssetVerification',
  DOCUMENT_REVIEW: 'DocumentReview',
};

export const EntityAssignmentType = {
  ASSET: 'Asset',
  INCOME: 'Income',
  BORROWER: 'Borrower',
  PROPERTY: 'Property',
};

export const RootCategory = {
  global: 'globalTaskCategory',
  local: 'localTaskCategory',
  withoutCategory: 'withoutCategory',
};

export const TaskScopeGroup = {
  GLOBAL: 'Global',
  LOCAL: 'Local',
};

export const TaskCategoriesTreeItemTypes = {
  root: 'root',
  taskCategory: 'taskCategory',
  taskType: 'taskType',
};

export const RootTreeCategories = {
  global: {
    id: RootCategory.global,
    parentId: null,
    name: 'Global categories',
    type: TaskCategoriesTreeItemTypes.root,
  },
  local: {
    id: RootCategory.local,
    parentId: null,
    name: 'Local categories',
    type: TaskCategoriesTreeItemTypes.root,
  },
  withoutCategory: {
    id: RootCategory.withoutCategory,
    parentId: null,
    name: 'Without category',
    type: TaskCategoriesTreeItemTypes.root,
  },
};

export const TaskActionType = {
  FREE_TEXT: 'FreeText',
  DOCUMENT: 'Document',
  FORM: 'Form',
  PAYMENT: 'Payment',
  UPDATE_LOAN_ADDRESS: 'UpdateLoanAddress',
};

export const LoanTaskFormStatus = {
  NEW: 'New',
  READY_TO_PROCESS: 'ReadyToProcess',
  IN_PROCESS: 'InProcess',
  DONE: 'Done',
};

export const PaymentSource = {
  FEE: 'Fee',
};
